/**
 *
 * @param {string} val
 * @return {string}
 */
export default (val: string): string => val;
